export enum DeviceTypeFilter {
  TV_SCREEN= "tv_screen",
  SECOND_SCREEN= "small_screen",
}
